let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("adH3p"), load("hD56l"), load("5uN9h"), load("jzQ6f")]).then(() => parcelRequire('ylKHA'));